import { render, staticRenderFns } from "./MeetingDocuments.vue?vue&type=template&id=2bb6d64b&"
import script from "./MeetingDocuments.vue?vue&type=script&lang=js&"
export * from "./MeetingDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports